import http from "@/axios";

class Dashboard {
	async index(payload?: object): Promise<any> {
		return await http.get("/dashboard/index", { params: payload });
	}
}
export default new Dashboard();
